import lessRequire from '../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';

lessRequire('modules/shared/tooltip.less');

const Tooltip = props => {
	return (
		<span className="tooltip">
			{props.children}
		</span>
	);
};

Tooltip.propTypes = {
	children: PropTypes.node
};

export default Tooltip;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/tooltip.js